module.exports = __webpack_public_path__ + "static/media/key-glow-rays.dffe0f7e.png";